import React, {useCallback, useMemo, useRef, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import responsibleMaintenanceService from "../../../../services/web/responsible-maintenance-service.js";
import {useQuery} from "@tanstack/react-query";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const initialFilters = {name: ""}

const ResponsibleMaintenanceList = () => {
    const navigate = navigateHook();

    const [filter, setFilter] = useState([]);
    const [filterValues, setFilterValues] = useState(initialFilters);

    const {data} = useQuery({
        queryFn: () => responsibleMaintenanceService.list(filter),
        queryKey: ["list", {filter}]
    });

    const [columnDefs,] = useState([
        { field: "id", headerName: "ID", width: 60},
        { field: "name", headerName: "Nome", sort: "asc", flex: 1, comparator: aggridUtils.nullLastComparator},
    ]);

    const gridRef = useRef(undefined);

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const apply = useCallback(() => {
        setFilter(Object.keys(filterValues).map(field => ({field, type: "like", value: filterValues[field]})))
    }, [filterValues])

    const clear = useCallback(() => {
        setFilterValues(initialFilters);
        setFilter([]);
    }, [])

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clear);

    const onCellClicked = ({data}) => {
        navigate(`/responsible-maintenance/form/${data.id}`)
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>Responsáveis por manutenção</Template.Title>

                <Button target={"primary"} onClick={() => navigate("/responsible-maintenance/form")}>
                    <FaPlus/> Adicionar responsável
                </Button>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <div className="flex justify-between gap-4">
                            <InputForm
                                classNameWrapper={"w-full"}
                                id={"name"}
                                label={"Nome"}
                                name={"name"}
                                value={filterValues.name}
                                onChange={({target: {value}}) => setFilterValues(prev => ({...prev, name: value}))}
                            />

                            <div className={"flex gap-2"}>
                                <Button target={"default"} onClick={clear} title={"Limpar"}>
                                    <FaEraser />
                                </Button>
                                <Button onClick={apply} title={"Buscar"}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className={"h-[calc(100vh-153px)] aggrid-row-pointer"}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default ResponsibleMaintenanceList;